import axiosClient from "api/apiClient";

interface IOptions {
    id?: string;
    sort?: string;
    search?: string;
}

export const APIGetTeacher = (options: IOptions) => {
    let sort = "";
    let search = "";
    if (options.hasOwnProperty("sort")) {
        sort = "&sort=" + options.sort;
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.sort;
    }
    return axiosClient.get(`/teachers/${options.id}?${search}${sort}`);
};

export const APIUpdateTeacher = (id: string, data: object) => {
    return axiosClient.put(`/teachers/${id}`, data);
};

export const APIPostTeacher = (data: object) => {
    return axiosClient.post(`/teachers`, data);
};
